import React from 'react';
import { jsx, Fragment } from 'react/jsx-runtime';

const TabContent = props => {
  const {
    activeTab,
    panelChildren,
    lazyload,
    type
  } = props;
  if (!panelChildren) return null;
  if (panelChildren?.every(x => {
    return x?.props && (!('children' in x.props) || x.props.children === null);
  })) {
    return null;
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: panelChildren?.map((child, index) => {
      return /*#__PURE__*/React.cloneElement(child, {
        key: index,
        lazyload,
        type,
        isActive: child.key === activeTab,
        ...child.props
      });
    })
  });
};

export { TabContent };
